/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `db` - db
 * @export
 */
export const FeatureFlagEntrySourceEnum = {
  db: 'db',
} as const;
export type FeatureFlagEntrySourceEnum = (typeof FeatureFlagEntrySourceEnum)[keyof typeof FeatureFlagEntrySourceEnum];

export function instanceOfFeatureFlagEntrySourceEnum(value: any): boolean {
  for (const key in FeatureFlagEntrySourceEnum) {
    if (Object.prototype.hasOwnProperty.call(FeatureFlagEntrySourceEnum, key)) {
      if ((FeatureFlagEntrySourceEnum as Record<string, FeatureFlagEntrySourceEnum>)[key] === value) {
        return true;
      }
    }
  }
  return false;
}

export function FeatureFlagEntrySourceEnumFromJSON(json: any): FeatureFlagEntrySourceEnum {
  return FeatureFlagEntrySourceEnumFromJSONTyped(json, false);
}

export function FeatureFlagEntrySourceEnumFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): FeatureFlagEntrySourceEnum {
  return json as FeatureFlagEntrySourceEnum;
}

export function FeatureFlagEntrySourceEnumToJSON(value?: FeatureFlagEntrySourceEnum | null): any {
  return value as any;
}
